class iScrollScripts {
    constructor(sel, sx, sy) {
        this.sel = sel;
        this.sx = sx;
        this.sy = sy;
    }
    init() {
        const sx = this.sx;
        const sy = this.sy;
        if (jQuery(this.sel).length > 0){
            const myScroll = new IScroll( this.sel , {
                mouseWheel: true,
                scrollbars: false,
                click:true,
                scrollX: sx,
                scrollY: sy,
            });
        }

    }
}

function countWidth() {
    if (jQuery('.archive-sidebar-scroll-mobile').length){
        let width = 0;
        jQuery('.archive-sidebar-scroll-mobile li').each(function(){
            const curr = jQuery(this).outerWidth();
            width += curr;
        });
        jQuery('.archive-sidebar-scroll-mobile').width(width);
    }
}
const SidebarScroll = new iScrollScripts('.archive-sidebar-content', false, true);
const SidebarScrollMobile = new iScrollScripts('.archive-sidebar-content-mobile', true, false);
const SideNavScroll = new iScrollScripts('.side-nav-content', false, true);

export default SidebarScroll;
export { SidebarScrollMobile };
export { SideNavScroll };
export { countWidth };

